import { render, staticRenderFns } from "./AssetView.vue?vue&type=template&id=5707669b&scoped=true&"
import script from "./AssetView.vue?vue&type=script&lang=ts&"
export * from "./AssetView.vue?vue&type=script&lang=ts&"
import style0 from "./AssetView.vue?vue&type=style&index=0&id=5707669b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707669b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VBtn,VBtnToggle,VContainer,VIcon,VMain})
